__turbopack_context__.v({
  "actions": "NewMessageForm-module__0jz4YG__actions",
  "form": "NewMessageForm-module__0jz4YG__form",
});
